"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _config = require("@concur/nui-logger/lib/config");
var _config2 = require("@concur/nui-auth/lib/config");
var _merge = _interopRequireDefault(require("lodash/merge"));
var _nuiConfig = _interopRequireDefault(require("@concur/nui-config"));
var _config3 = require("../config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
This is to return combined config for app and packages
*/
var _default = exports.default = function _default(config, options) {
  return (0, _nuiConfig.default)((0, _merge.default)(_config3.configDefaults, _config.configDefaults, _config2.configDefaults, config), options);
};